<template>
  <p>
    VIZBI 2015, the 6<sup>th</sup> international meeting on Visualizing Biological Data, was held
    March 25&ndash;27 at the
    <a href="http://www.broadinstitute.org/">Broad Institute of MIT and Harvard</a>,
    Cambridge MA, USA.
  </p>
  <HeroImage hero-image="Hero.png" flyer-hi-res="Poster.pdf" />
  <p>
    VIZBI 2015 featured
    <router-link to="People">21 invited talks</router-link>
    reviewing the state-of-the-art and challenges in visualizing data from genomes, transcripts,
    proteins, cells, organisms, and populations. Prior to the meeting (March 24), there were
    tutorials on several visualization tools.
  </p>
  <p>
    All participants had the opportunity to present a poster describing their work. Just before each
    poster session, participants were given 60 seconds and 2 slides to briefly introduce themselves
    and their poster to all VIZBI participants.
  </p>
  <p>
    If you could not join us in Cambridge, virtual
    <router-link to="Registration">registration</router-link>
    allowed participation in the conference (but not tutorials) via streaming video.
  </p>
  <p>
    As with previous meetings, VIZBI 2015 was an exciting event that helped raise the standard of
    data visualization in the life sciences. Highlights from the meeting are available on the VIZBI
    <router-link to="/blog">blog</router-link>,
    <router-link to="/Posters/2015">posters</router-link>,
    <router-link to="/photos/2015">photos</router-link>, and
    <router-link to="/videos">videos</router-link> pages.
  </p>
  <p>
    Funding for this conference was made possible in part by NIH grant R13LM010987. The views
    expressed in written conference materials or publications and by speakers and moderators do not
    necessarily reflect the official policies of the Department of Health and Human Services; nor
    does mention of trade names, commercial practices, or organizations imply endorsement by the
    U.S. Government.
  </p>
  <p>
    To receive updates about VIZBI, you can join the
    <a href="http://vizbi.org/blog/vizbi-mailing-list/">VIZBI mailing list</a>.
  </p>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>
